import React, { useEffect, useState } from "react";
import {
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Table,
    Card,
    CardBody,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import TableContainer from "components/Common/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, fetchPayrollStopPaymentRequest, savePayrollStopPaymentRequest, saveReopenpayment } from "store/actions";
import CustomMonthPicker from "common/CustomMonthPicker";
import CustomSelect from "components/Common/custom-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "common/pageLoader";
// import { FiXCircle } from "react-icons/fi";
// import { FiTrash2 } from "react-icons/fi";
import { FiRotateCcw } from "react-icons/fi";
import Swal from "sweetalert2";

const paymentmode = [
    { label: "Cash", value: "1" },
    { label: "Cheque", value: "2" },
    { label: "Bank", value: "3" },
];

const StopPayment = () => {
    const dispatch = useDispatch();
    const [authDetails, setAuthDetails] = useState(null);
    const [modal, setModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const toggle = () => {
        setModal(!modal);

        formik.setFieldValue("date", "");
        formik.setFieldValue("reason", "");
        formik.setFieldValue("referenceNo", "");
        formik.setFieldValue("remarks", "");
    };
    const {
        stopPayments,
        employees,
        loading,
        success,
        error,
    } = useSelector((state) => ({
        stopPayments: state.PayrollSalaryStopPaymentReducer?.stopPayments ?? [],
        employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
        loading: state.PayrollSalaryStopPaymentReducer?.loading || state.EmployeeDetailsReducer?.loading,
        error: state.PayrollSalaryStopPaymentReducer?.error || state.EmployeeDetailsReducer?.error,
        success: state.PayrollSalaryStopPaymentReducer?.success,
    }));

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchPayrollStopPaymentRequest(unitId));
        dispatch(fetchActiveEmployees(unitId))
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            formik.resetForm();
            transferFormik.resetForm();
            setModal(false);
            dispatch(fetchPayrollStopPaymentRequest(authDetails?.unit_id));
        }
    }, [authDetails, success, dispatch]);

    const handleDelete = (rowData, index) => {
        setSelectedRow(rowData);
        setModal(true);
    };

    const columns = [
        { Header: "S.No", Cell: ({ row }) => stopPayments.length - row.index, className: "serial-no text-center", },
        { Header: "Code", accessor: "emp_no", className: "text-left", },
        { Header: "Employee Name", accessor: "emp_name", className: "text-left", },
        { Header: "Month", accessor: "stoppay_month", className: "text-center", },
        {
            Header: "Reactivate",
            Cell: ({ row }) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <FiRotateCcw size={18} style={{ color: "blue", cursor: "pointer" }} title="Reactivate Payment" onClick={() => handleDelete(row.original, row.index)} />
                    </div>
                );
            }
        }
    ];

    const formik = useFormik({
        initialValues: {
            fromDate: "",
            employee: "",
            reason: "",
            referenceNo: "0",
            date: "",
            remarks: "",
        },
        validationSchema: Yup.object({
            employee: Yup.object().nullable().required("Employee is required"),
            fromDate: Yup.date().typeError("Invalid date").required("Month is required"),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append("emp_id", values.employee?.value);
            formData.append("sal_month", values.fromDate);
            formData.append("create_by", authDetails?.user_id);
            dispatch(savePayrollStopPaymentRequest(formData));
        },
    });

    const transferFormik = useFormik({
        initialValues: {
            fromDate: "",
            employee: "",
            reason: "",
            referenceNo: "0",
            date: "",
            remarks: "",
        },
        validationSchema: Yup.object({
            date: Yup.string().required("Date is required"),
            remarks: Yup.string().required("Remarks is required"),
            reason: Yup.string().required("Reason is required"),
            // referenceNo: Yup.number().required("Amount required")
            referenceNo: Yup.string()
                .required("Amount No is required")
                .when("reason", {
                    is: "1", // Cash
                    then: Yup.string()
                        .matches(/^[0-9]+$/, "Cash amount must contain only numbers"),
                    otherwise: Yup.string()
                        .matches(/^[a-zA-Z0-9]+$/, "Only alphabets and numbers allowed"),
                }),
        }),

        onSubmit: (values) => {
            const formatDate = (dateStr) => {
                const [day, month, year] = dateStr.split("/");
                return `${year}-${month}-${day}`;
            };
            const formData = new FormData();
            formData.append("payment_mode", values.reason);
            formData.append("reference_no", values.referenceNo || 0);
            formData.append("payment_date", values.date);
            formData.append("emp_id", selectedRow?.emp_id);
            formData.append("remarks", values.remarks || "  ");
            formData.append("create_by", authDetails?.user_id || 0);
            formData.append("unit_id", authDetails?.unit_id || 0);
            formData.append("sal_month", formatDate(selectedRow?.api_stoppay_month));
            dispatch(saveReopenpayment(formData));
        },
    });

    const getPaymentLabel = () => {
        switch (transferFormik.values.reason) {
            case "1":
                return "Cash Amount";
            case "2":
                return "Cheque No";
            case "3":
                return "Account No";
            default:
                return "Reference No";
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Payroll / Salary" breadcrumbItem="Stop Payment" />
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <Form onSubmit={formik.handleSubmit}>
                                        <Row>
                                            {/* Employee Selection */}
                                            <Col md={3} sm={12} className="mb-3">
                                                <FormGroup>
                                                    <Label for="employee">Employee <span className="text-danger">*</span></Label>
                                                    <CustomSelect
                                                        id="employee"
                                                        name="employee"
                                                        options={employees}
                                                        value={formik.values.employee || null}  // Store full object
                                                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                                                    />
                                                    {formik.touched.employee && formik.errors.employee && (
                                                        <div className="text-danger">{formik.errors.employee}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* From Date */}
                                            <Col md={3} sm={12} className="mb-3">
                                                <FormGroup>
                                                    <Label for="fromDate">Month <span className="text-danger">*</span></Label>
                                                    <CustomMonthPicker
                                                        name="fromDate"
                                                        value={formik.values.fromDate}
                                                        onChange={(date) => formik.setFieldValue("fromDate", date)}
                                                        onBlur={formik.handleBlur}
                                                        disablePast={true}
                                                        className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                                                    />
                                                    {formik.touched.fromDate && formik.errors.fromDate && (
                                                        <div className="text-danger">{formik.errors.fromDate}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={6} className="text-end d-flex align-items-center justify-content-end">
                                                <Button type="submit" className="btn button-save me-2"><i className="fas fa-save me-1" /> Save</Button>
                                                {/* <Button type="reset" className="btn button-cancel" onClick={() => formik.resetForm()}><i className="fas fa-sync me-1" /> Cancel</Button> */}
                                                <Button
                                                    type="button"
                                                    className="btn button-cancel"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            title: "Are you sure?",
                                                            text: "All entered data will be cleared.",
                                                            icon: "warning",
                                                            showCancelButton: true,
                                                            confirmButtonText: "Yes, Cancel",
                                                            cancelButtonText: "No",
                                                            confirmButtonColor: "#3085d6",
                                                            cancelButtonColor: "#d33"
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                formik.resetForm();
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <i className="fas fa-sync me-1" /> Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <TableContainer columns={columns} data={stopPayments && stopPayments.length > 0 ? stopPayments : []} isGlobalFilter={true} customPageSize={10} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal isOpen={modal} toggle={toggle} centered>
                        <ModalHeader toggle={toggle}>Stop Payment Action</ModalHeader>
                        <ModalBody>
                            <Form onSubmit={transferFormik.handleSubmit}>
                                <FormGroup>
                                    <Label>Reactivate Month <span className="text-danger">*</span></Label>
                                    <CustomMonthPicker
                                        name="date"
                                        value={transferFormik.values.date}
                                        onChange={(date) => transferFormik.setFieldValue("date", date)}
                                        onBlur={transferFormik.handleBlur}
                                        className={`form-control ${transferFormik.touched.date && transferFormik.errors.date ? "is-invalid" : ""}`}
                                    />
                                    {transferFormik.touched.date && transferFormik.errors.date && (
                                        <div className="text-danger">{transferFormik.errors.date}</div>
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <Label>Payment Mode <span className="text-danger">*</span></Label>
                                    <Input type="select" name="reason" value={transferFormik.values.reason} onChange={transferFormik.handleChange} placeholder="select">
                                        <option value="">select</option>
                                        {paymentmode.map((item) => (
                                            <option key={item.value} value={item.value}> {item.label} </option>
                                        ))}
                                    </Input>
                                    {transferFormik.touched.reason && transferFormik.errors.reason && (
                                        <div className="text-danger">{transferFormik.errors.reason}</div>
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <Label>{getPaymentLabel()} <span className="text-danger">*</span></Label>
                                    {/* <Input type="text" name="referenceNo" value={transferFormik.values.referenceNo} onChange={transferFormik.handleChange} /> */}
                                    <Input
                                        type="text"
                                        name="referenceNo"
                                        value={transferFormik.values.referenceNo}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const mode = transferFormik.values.reason;

                                            if (mode === "1") {
                                                // Cash → numbers only
                                                if (/^[0-9]*$/.test(value)) {
                                                    transferFormik.setFieldValue("referenceNo", value);
                                                }
                                            } else if (mode === "2" || mode === "3") {
                                                // Cheque / Bank → alphabets + numbers
                                                if (/^[a-zA-Z0-9]*$/.test(value)) {
                                                    transferFormik.setFieldValue("referenceNo", value);
                                                }
                                            } else {
                                                transferFormik.setFieldValue("referenceNo", value);
                                            }
                                        }}
                                    />
                                    {transferFormik.touched.referenceNo && transferFormik.errors.referenceNo && (
                                        <div className="text-danger">{transferFormik.errors.referenceNo}</div>
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <Label>Remarks <span className="text-danger">*</span></Label>
                                    <Input
                                        type="textarea"
                                        name="remarks"
                                        rows="3"
                                        maxLength={50}
                                        value={transferFormik.values.remarks}
                                        onChange={transferFormik.handleChange}
                                        onBlur={transferFormik.handleBlur}
                                        className={`form-control ${transferFormik.touched.remarks && transferFormik.errors.remarks ? "is-invalid" : ""}`}
                                    />
                                    {transferFormik.touched.remarks && transferFormik.errors.remarks && (
                                        <div className="text-danger">{transferFormik.errors.remarks}</div>
                                    )}
                                </FormGroup>
                                <ModalFooter>
                                    <Button color="primary" type="submit">Submit</Button>
                                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                                </ModalFooter>
                            </Form>
                        </ModalBody>
                    </Modal>
                </Container>
            </div >
        </React.Fragment >
    );
};

export default StopPayment;
